module.exports = __webpack_public_path__ + "static/media/goto-fight.22eecd74.mp3";